import { graphql } from 'src/graphql';

export const ShareFieldsFragment = graphql(`
  fragment ShareFieldsFragment on Share @_unmask {
    _id
    status
    invitee_email
    domain
  }
`);
